import React from 'react';

import { PremiumProgramTag } from './premium-program-tag';
import { ShopPromiseLogo } from './shop-promise-logo';

import style from './shop-promise-tag.module.less';

export const ShopPromiseTag = () => {
  return (
    <PremiumProgramTag className={style['shop-promise-tag']}>
      <ShopPromiseLogo className={style['shop-promise-logo']} />
    </PremiumProgramTag>
  );
};
